/** Toast copy for refused image attachments in agent composers. */
export const IMAGE_INPUT_WARNING =
  'This model does not support images. Choose a vision model to attach images.';
